import React, { FC, useState } from 'react';
import { IContract, IPayout, ICashFlowData, ICalculationParametersData } from 'types';
import { useAppDispatch } from 'store';
import {
  loadContractPayoutsAction,
  loadCashFlowsAction,
  loadCalculationParametersAction,
  loadDownloadExcelAction
} from 'store/contracts/contracts.reducer';
import { ContractView } from '../components/ContractView/ContractView';

interface Props {
  contract: IContract;
  measure?: () => void;
}

export const Contract: FC<Props> = ({ contract, measure }) => {
  const [payouts, setPayouts] = useState<IPayout[]>([]);
  const [cashFlows, setCashFlows] = useState<ICashFlowData[]>([]);
  const [calculationParameters, setCalculationParameters] = useState<ICalculationParametersData[]>([]);
  const dispatch = useAppDispatch();

  const handleLoadPayouts = async () => {
    const payoutsData = await dispatch(loadContractPayoutsAction(contract.idContract));
    setPayouts(payoutsData);
  };

  const handleLoadCashFlows = async () => {
    const cashFlowsData = await dispatch(loadCashFlowsAction(contract.idContract));
    setCashFlows(Array.isArray(cashFlowsData) ? cashFlowsData : [cashFlowsData]);
  };
  
  const handleLoadCalculationParameters = async () => {
    const calcParamsData = await dispatch(loadCalculationParametersAction(contract.idContract));
    setCalculationParameters(Array.isArray(calcParamsData) ? calcParamsData : [calcParamsData]);
  };

const handleDownloadExcel = async () => {
const blob = await dispatch(loadDownloadExcelAction(contract.idContract));
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'График платежей.xlsx';
  a.click();
  URL.revokeObjectURL(url);
};


  return (
    <ContractView 
      measure={measure} 
      contract={contract} 
      payouts={payouts} 
      cashFlows={cashFlows} 
      calculationParameters={calculationParameters}
      onLoadPayouts={handleLoadPayouts}
      onLoadCashFlows={handleLoadCashFlows} 
      onLoadCalculationParameters={handleLoadCalculationParameters} 
      onDownloadExcel={handleDownloadExcel}
    />
  );
};
